/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import vuetify from './vuetify'
import jQuery from 'jquery'
import Aos from 'aos'
import moment from 'moment'
import 'aos/dist/aos.css'
import * as convert from 'color-convert'
import Vue from 'vue'
import tinymce from 'tinymce'
import 'tinymce/themes/silver'
import 'tinymce/icons/default/icons'
import 'tinymce-i18n/langs/fr_FR'
import contentUiCss from 'tinymce/skins/ui/oxide/content.css';
import skinUiCss from 'tinymce/skins/ui/oxide/skin.css';
import contentCss from 'tinymce/skins/content/default/content.css';
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import Cookies from 'js-cookie';
import store from './store'
import axios from 'axios';
import VueAxios from 'vue-axios'
import vSelect from "vue-select";
import Quill from 'quill';

Vue.use(VueAxios, axios)

var momentRange = require('moment-range');
momentRange.extendMoment(moment);

require('./bootstrap')
require('./modal')

window.jQuery = jQuery
window.Aos = Aos
window.moment = moment
window.colorConvert = convert
window.tinymce = tinymce
window.contentUiCss = contentUiCss
window.skinUiCss = skinUiCss
window.contentCss = contentCss
window.Cookies = Cookies
window.Quill = Quill

window.Vue = require('vue').default
Vue.component('admin-sidebar', require('./components/AdminSidebar.vue').default)
// Vue.component("carousel-component", require("./components/App.vue").default);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('color-picker', require('./components/ColorPicker.vue').default)
Vue.component('carousel-custom', require('./components/Carousel.vue').default)
Vue.component('time-slot', require('./components/TimeSlot.vue').default)
Vue.component('calendar-custom', require('./components/Calendar/Calendar.vue').default)
Vue.component('Product', require('./components/Calendar/Modal/Product.vue').default)
// Vue.component('calendar-custom2', require('./components/Calendar2/Calendar.vue').default)
Vue.component('list-prescriptions', require('./components/PrescriptionsList.vue').default)
// Vue.component('carousels-prescriptions', require('./components/CarouselsPrescription.vue').default)
Vue.component('prestation-select', require('./components/Prestation_BO/Prestation.vue').default)

Vue.component('info-establishment', require('./components/Basket/BasketEstablishment.vue').default)
Vue.component('survey-question', require('./components/Surveys/SurveyQuestion.vue').default)
Vue.component('survey-fo', require('./components/Surveys/SurveyFO.vue').default)
Vue.component('survey-form', require('./components/Surveys/SurveyForm.vue').default)
Vue.component('series-form', require('./components/Series/PrestationsForm.vue').default)

Vue.component('checkout-component', require('./components/Checkout_BO/Checkout.vue').default)
Vue.component('checkout-overlay', require('./components/Checkout_BO/CheckoutOverlay/Overlay.vue').default)
Vue.component('waiting-sales-tab', require('./components/Checkout_BO/CheckoutOverlay/WaitingSales.vue').default)
Vue.component('serie-treatment-tab', require('./components/Checkout_BO/CheckoutOverlay/SerieTreatment.vue').default)
Vue.component('avoir-tab', require('./components/Checkout_BO/CheckoutOverlay/Avoir.vue').default)
Vue.component('serie-treatment-modal', require('./components/Checkout_BO/CheckoutOverlay/SerieTreatmentModal.vue').default)
Vue.component('voucher-tab', require('./components/Checkout_BO/CheckoutOverlay/Voucher.vue').default)
Vue.component('cart-component', require('./components/Checkout_BO/CheckoutOverlay/Cart.vue').default)
Vue.component('payment-component', require('./components/Checkout_BO/CheckoutOverlay/Payment.vue').default)
Vue.component('close-sale-modal', require('./components/Checkout_BO/CheckoutOverlay/CloseSaleModal.vue').default)
Vue.component('staff-modal', require('./components/Checkout_BO/CheckoutOverlay/StaffModal.vue').default)
Vue.component('Staff', require('./components/Staff.vue').default)
Vue.component('calenders', require('./components/CalenderS.vue').default)

Vue.component('treatment-timeline', require('./components/Treatment/TreatmentTimeline').default)
Vue.component('payment-method-component', require('./components/Order/PaymentMethod.vue').default)
Vue.component('payment-method-amount-component', require('./components/Order/PaymentMethodAmount.vue').default)
Vue.component("vue-select", vSelect);
Vue.component('suggest-offers', require('./components/SuggestOffers').default)
Vue.component('email-marketing', require('./components/EmailMarketing').default)
Vue.component('AddNewPaymentCard', require('./components/Checkout_BO/CheckoutOverlay/AddNewCard.vue').default)

// table vue
Vue.component( 'vouchers-table', require('./components/SwitchView/Voucher/VouchersTable.vue').default )
Vue.component( 'customers-table', require('./components/SwitchView/Customer/CustomersTable.vue').default )
Vue.component( 'customers-vouchers-table', require('./components/SwitchView/Voucher/CustomerVoucherTable.vue').default )
Vue.component( 'order-payment-history', require('./components/Order/OrderPaymentHistory.vue').default )
Vue.component( 'order-invoice-history', require('./components/Order/InvoiceHistory.vue').default )
//Vue.component('serie-timeline', require('./components/Serie/SerieTimeline').default)
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import Pathify from 'vuex-pathify'

Pathify.options.deep = 2

const app = new Vue({
  el: '#page-container',
  store,
  vuetify,
  data: {
    menu: false
  },
  methods: {
    newCardAdded() {
      console.log('Card added')
      if (window.location.pathname.includes('/payment/edit')) {
        window.location.reload()
      }
    },
    closeCardModal() {
      this.menu = false
    },
  },
})
